/** 
  环境配置封装
*/
const env =
    import.meta.env.MODE

const envConfig = {
    dev: {
        baseUrl: 'https://falcon5-app.mockmain.com',
        baseApi: 'https://falcon5-app.mockmain.com/api',
        engineApi: 'http://falcon5-engine-test.mockmain.com',
        officialWebsite: 'https://ltranslate.cn',
        mockApi: '/',
    },
    test: {
        baseUrl: 'https://test-falcon5-app.thwpmanage.com',
        baseApi: 'https://test-falcon5-app.thwpmanage.com/api',
        mockApi: '/',
    },
    ctoTest: {
        baseUrl: 'https://cto-test-falcon5-app.thwpmanage.com',
        baseApi: 'https://cto-test-falcon5-app.thwpmanage.com/api',
        mockApi: '/',
    },
    pre: {
        baseUrl: 'https://pre-falcon5-app.thwpmanage.com',
        baseApi: 'https://pre-falcon5-app.thwpmanage.com/api',
        officialWebsite: 'https://ltranslate.cn',
        mockApi: '/',
    },
    pro: {
        baseUrl: 'https://platform.ltranslate.cn',
        baseApi: 'https://platform.ltranslate.cn/api',
        engineApi: 'http://engine.ltranslate.cn/',
        officialWebsite: 'https://ltranslate.cn',
        mockApi: '/',
    },
}

export default {
    env,
    mock: false,
    namespace: 'manager',
    ...envConfig[env],
}